/* eslint-disable */
import React, {Component} from 'react';

import Classes from './NextSong.css'
import NextSongItem     from './NextSongItem/NextSongItem';
import Aux              from '../../hoc/Aux';
import FlipMove         from 'react-flip-move';
import logger           from './../../logger';

class NextSong extends Component {

    render() {

        let song_to_display = this.props.songs.map( song  =>  {
            let _trend ="positive";
            if(Math.abs(song.like) < Math.abs(song.unlike) ){
                _trend = "negative"   
            }

            return <NextSongItem
                    trend       = {_trend}
                    songImage   = {song.cover}
                    songName    = {song.name}
                    songAuthor  = {song.artist}
                    pictureUser = {song.user.picture}
                    key         = {song.id}
                />       
        });

    return(    
        <Aux>
            <h4 className={Classes.Title}>{this.props.upcomingTitle}</h4>
            <hr/>
            <FlipMove
                enterAnimation="fade" 
                leaveAnimation="fade"
                duration="2000">
            { song_to_display }
            </FlipMove>
        </Aux>
    )
  }
}

export default NextSong;